<template style="background-color: #ff4354">
  <div id="app">
    <VBox id="vertical">
      <img src="./assets/chef.jpg" id="chef_logo">
      <h1>Cookay - Your AI personal chef</h1>
      <h2>Ready, set, cook!</h2>
    </VBox>
  
    <!-- <HBox id="horizontal">
      <button id="main_button">My leftovers</button>
      <button id="main_button">Recipe builder</button>
      <button id="main_button">About</button>
    </HBox> -->

    <VBox id="vertical">
      <input type="text" id="input" placeholder="Leftovers" v-model="leftovers">
      <input type="text" id="input" placeholder="Experience level" v-model="exp">
      <input type="text" id="input" placeholder="Time to cook" v-model="time">

      <button id="main_button" @click="showRecipe()">Submit</button>
      <h4 v-if="loading">Loading...</h4>
  
      <template v-if="show">
        <tr>
          <td v-for="line in output" :key="line" id="vertical" style="font-size: 22px; text-align: center;">
            {{ line }}
            <br>
          </td>
        </tr>
      </template>
    </VBox>
  </div>
</template>

<script>
  const { GoogleGenerativeAI } = require("@google/generative-ai");
  const key = 'AIzaSyA-SdorcDkMJKdnxo3eyzEnmE2miRtg0yQ';
  const genAI = new GoogleGenerativeAI(key);

  export default {
    name: 'App',
    data() {
      return {
        msg: 'Recipe Builder',
        show: false,
        output: '-',
        loading: false,
      }
    },
    methods: {
      async showRecipe() {
        const prompt = "I have " + this.time + " minutes to cook a meal with the following ingredients: " + this.leftovers + ". My cooking experience is " + this.exp + ". What would you suggest? You should note the end of line with '<br>' to separate the lines. Remove all the '*' characters.";
        try {
          this.loading = true;
          const model = genAI.getGenerativeModel({ model: 'gemini-2.0-flash' });
          const result = await model.generateContent(prompt);
          const response = await result.response;
          const text = response.text();
          this.show = true;
          this.output = text.split('<br>');
          this.loading = false;
        } catch (error) {
          alert(error);
        }
      }
    }
  }
</script>

<style scoped src="./assets/style.css"></style>
